import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { ViolationInformationDialogComponent } from '@dialog/violation-information-dialog/violation-information-dialog.component';
import { CustomReuseStrategy } from '@library-shared/app-reuse-strategy';
import { ConfirmationDialogComponent } from '@library-shared/dialogs/confirmation-dialog/confirmation-dialog.component';
import { EmailDialogComponent } from '@library-shared/dialogs/email-dialog/email-dialog.component';
import { PinDialogComponent } from '@library-shared/dialogs/pin-dialog/pin-dialog.component';
import { SnapshotCreateDialogComponent } from '@library-shared/dialogs/snapshot-create-dialog/snapshot-create-dialog.component';
import { TtiCheckBoxComponent } from '@library-shared/form/tti-check-box/tti-check-box.component';
import { TtiSelectBoxComponent } from '@library-shared/form/tti-select-box/tti-select-box.component';
import { TtiTextAreaComponent } from '@library-shared/form/tti-text-area/tti-text-area.component';
import { TtiTextBoxComponent } from '@library-shared/form/tti-text-box/tti-text-box.component';
import { CheckCircleWidgetComponent } from '@library-shared/widget/check-circle-widget/check-circle-widget.component';
import { CookieCrumbsComponent } from '@library-shared/widget/cookie-crumb/cookie-crumbs.component';
import { FilterDateSelectComponent } from '@library-shared/widget/filter-date-select/filter-date-select.component';
import { InPlaceCheckBoxComponent } from '@library-shared/widget/in-place-check-box/in-place-check-box.component';
import { InPlaceDateBoxComponent } from '@library-shared/widget/in-place-date-box/in-place-date-box.component';
import { InPlaceSelectBoxComponent } from '@library-shared/widget/in-place-select-box/in-place-select-box.component';
import { ObjectViewComponent } from '@library-shared/widget/object-view/object-view.component';
import { PasswordStrengthMeterComponent } from '@library-shared/widget/password-strength-meter/password-strength-meter.component';
import { YearSelectComponent } from '@library-shared/widget/year-select/year-select.component';
import { WorkInProgressComponent } from '@library-shared/work-in-progress/work-in-progress.component';
import { AppRoutingModule } from '@system/app-routing.module';
import { AuthInterceptor } from '@system/authentication.interceptor';
import { PageNotFoundComponent } from '@system/page-not-found/page-not-found.component';
import { SiteResetComponent } from '@user/site-reset/site-reset.component';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxContextMenuModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDrawerModule,
  DxDropDownBoxModule,
  DxDropDownButtonModule,
  DxFileUploaderModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxMenuModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxRadioGroupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTabPanelModule,
  DxTabsModule,
  DxTemplateModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToastModule,
  DxToolbarModule,
  DxTooltipModule,
  DxTreeViewModule,
  DxValidationGroupModule,
  DxValidationSummaryModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { RecaptchaModule } from 'ng-recaptcha';
import { ClipboardModule } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { AffirmationComponent } from './affirmation/affirmation/affirmation.component';
import { PleadDialogComponent } from './dialog/plead-dialog/plead-dialog.component';
import { ViewDocComponent } from './doc/view-doc/view-doc.component';
import { PayTicketComponent } from './pay-ticket/pay-ticket.component';
import { ConfirmPaymentDialogComponent } from './pay-ticket/widgets/confirm-payment-dialog/confirm-payment-dialog.component';
import { CreditCardInformationComponent } from './pay-ticket/widgets/credit-card-information/credit-card-information.component';
import { FinalizePaymentComponent } from './pay-ticket/widgets/finalize-payment/finalize-payment.component';
import { MandatoryTermsComponent } from './pay-ticket/widgets/mandatory-terms/mandatory-terms.component';
import { TicketsToPayComponent } from './pay-ticket/widgets/tickets-to-pay/tickets-to-pay.component';
import { ReceiptComponent } from './receipt/receipt/receipt.component';
import { SampleTicketsNassauComponent } from './sample-tickets/sample-tickets-nassau/sample-tickets-nassau.component';
import { SearchComponent } from './search/search.component';
import { MaintenanceComponent } from './system/maintenance/maintenance.component';
import { TicketSelectComponent } from './ticket-select/ticket-select.component';
import { TicketSelectDisplayComponent } from './ticket-select/widget/ticket-select-display/ticket-select-display.component';
import { LoadingDivComponent } from './widget/loading-div/loading-div.component';

@NgModule({
  declarations: [
    AppComponent,
    CheckCircleWidgetComponent,
    ConfirmationDialogComponent,
    CookieCrumbsComponent,
    EmailDialogComponent,
    FilterDateSelectComponent,
    InPlaceCheckBoxComponent,
    InPlaceDateBoxComponent,
    InPlaceSelectBoxComponent,
    ObjectViewComponent,
    PageNotFoundComponent,
    PasswordStrengthMeterComponent,
    PinDialogComponent,
    SearchComponent,
    SiteResetComponent,
    SnapshotCreateDialogComponent,
    TtiCheckBoxComponent,
    TtiSelectBoxComponent,
    TtiTextAreaComponent,
    TtiTextBoxComponent,
    WorkInProgressComponent,
    YearSelectComponent,
    TicketSelectComponent,
    PayTicketComponent,
    CreditCardInformationComponent,
    TicketsToPayComponent,
    MandatoryTermsComponent,
    FinalizePaymentComponent,
    TicketSelectDisplayComponent,
    ConfirmPaymentDialogComponent,
    AffirmationComponent,
    ViewDocComponent,
    SampleTicketsNassauComponent,
    PleadDialogComponent,
    ViolationInformationDialogComponent,
    ReceiptComponent,
    MaintenanceComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    //-------
    LoadingDivComponent,
    //------
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    ClipboardModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDrawerModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxFileUploaderModule,
    DxFileUploaderModule,
    DxListModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    DxLoadPanelModule,
    DxMenuModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxTabPanelModule,
    DxTabsModule,
    DxTemplateModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToastModule,
    DxToolbarModule,
    DxTooltipModule,
    DxTreeViewModule,
    DxValidationGroupModule,
    DxValidationSummaryModule,
    DxValidatorModule,
    RecaptchaModule,
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
